import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'seagullbyte_cookie_consent';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if consent was already given
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 md:p-8">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/10 to-purple-500/10 flex items-center justify-center">
                <Cookie className="w-6 h-6 text-blue-600" />
              </div>
              
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Utilizziamo i cookie
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  Questo sito utilizza cookie tecnici necessari per il funzionamento e, con il tuo consenso, 
                  cookie analitici per migliorare l'esperienza di navigazione. 
                  Puoi accettare tutti i cookie o solo quelli necessari. 
                  Per maggiori informazioni consulta la nostra{' '}
                  <Link to="/cookie-policy" className="text-blue-600 hover:underline">
                    Cookie Policy
                  </Link>{' '}
                  e la{' '}
                  <Link to="/privacy-policy" className="text-blue-600 hover:underline">
                    Privacy Policy
                  </Link>.
                </p>
                
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={handleAcceptAll}
                    className="btn-primary text-sm px-6 py-3"
                    data-testid="cookie-accept-all"
                  >
                    Accetta tutti
                  </button>
                  <button
                    onClick={handleAcceptNecessary}
                    className="btn-secondary text-sm px-6 py-3"
                    data-testid="cookie-accept-necessary"
                  >
                    Solo necessari
                  </button>
                </div>
              </div>

              <button
                onClick={handleAcceptNecessary}
                className="flex-shrink-0 p-2 text-gray-400 hover:text-gray-600 transition-colors"
                aria-label="Chiudi"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
